import ProfileCommentsBox from './ProfileCommentsBox';
import ProfileCommentsContainer from './ProfileComments.container';

export default ProfileCommentsContainer(ProfileCommentsBox);
